import script from "./OTipoAtividadeId.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTipoAtividadeId.vue?vue&type=script&lang=ts&setup=true"

import "./OTipoAtividadeId.vue?vue&type=style&index=0&id=4dfc3653&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfc3653"]])

export default __exports__